import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const navItems = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/faq", label: "FAQ" },
    { to: "/journal", label: "Journal" },
    { to: "/agents", label: "For Agents" },
    { to: "/get-started", label: "Get Matched Now!" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="glass-nav fixed top-0 inset-x-0 z-50"
            data-testid="site-navbar"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between h-16">
                <Link
                    to="/"
                    className="font-serif text-xl tracking-tight text-brand-ink"
                    data-testid="nav-logo-link"
                    onClick={() => setOpen(false)}
                >
                    Realtor<span className="italic text-brand-gold">Referral</span>
                    <span className="text-xs align-top ml-0.5">.ca</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    {navItems.slice(0, -1).map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `text-sm tracking-wide transition-colors ${
                                    isActive
                                        ? "text-brand-ink"
                                        : "text-brand-muted hover:text-brand-ink"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/get-started"
                        data-testid="nav-cta-button"
                        className="text-sm tracking-wide px-5 py-2.5 bg-brand-ink text-brand-paper hover:bg-black transition-colors"
                    >
                        Get Matched Now!
                    </Link>
                </nav>

                <button
                    className="md:hidden p-2 -mr-2 text-brand-ink"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-brand-line bg-brand-paper">
                    <nav className="px-6 py-4 flex flex-col gap-3">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `text-base py-1 ${
                                        isActive ? "text-brand-ink" : "text-brand-muted"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
